(async () => {
  const el = document.getElementById('about-us-index')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/about-us/index.vue'),
    },
  ]

  await clientRender({ components })
})()
